<template>
  <UserPasswordForm :user="user"
                    @formSubmit="formSubmitted($event)" />
</template>

<script>
import store from "../User/UserStore";
import UserPasswordForm from "./UserPasswordForm.vue";
import UserPasswordMixin from "./UserPasswordMixin";

const responseStore = {
  response: null
};

export default {
  name: "UserPasswordEdit",

  title () {
    return this.$t("user.changePass") + ` - ${Dashboard.currentTenant.name}`;
  },

  components: {
    UserPasswordForm
  },

  mixins: [UserPasswordMixin],

  data: function () {
    return {
      responseStore: responseStore
    };
  },

  mounted () {
    this.addBreadcrumb(this.$t("sidebar.changePassword"));
  },

  methods: {
    async formSubmitted (e) {
      let responseJSON = await store.updateUserPassword(this.user);

      if (responseJSON.success) {
        this.notifySuccess(responseJSON.successMessage);
      } else {
        this.notifyErrors(responseJSON.errorMessages);
      }
      e.target.reset();
      e.preventDefault();
    }
  }
};
</script>
